import { Fragment, useState, useRef, useEffect, useContext } from "react";
import * as Yup from "yup";
import { modalContext } from "../../root";
import axios from "../../../../services/index.service";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import BottomButton from "../../../../components/DocButtomButton";
import CustomInput from "../../../../components/CustomInput";
import { updateDeliveryFee } from "../../../../actions/delivery.action";
import ErrorInputComponent from "../../../../components/ErrorInputComponent";
import { hideModal } from "../../../../actions/modal.action";

export default function EditDeliveryFeeModal() {
  const modalData = useContext(modalContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(true);
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStationNames();
  }, []);

  const getStationNames = () => {
    setLoading(true);
    axios.get(`v1/api/services/delivery-stations/names`).then((res) => {
      if (res?.data !== undefined) {
        if (Object.keys(res?.data).length) {
          setNames(res.data.data);
        }
      }
    });
    setLoading(false);
  };

  const {
    deliveryFee: { deliveryFeeLoading },
  } = useSelector(({ deliveryFeeReducer }) => ({
    deliveryFee: deliveryFeeReducer,
  }));

  const closeModal = () => {
    setOpen(false);
    dispatch(hideModal());
  };

  const validationSchema = Yup.object({
    code: Yup.string().required("Station is required"),
    gigAmount: Yup.string().required("GIG amount is required"),
    compassAmount: Yup.string().required("Compass amount is required"),
  });

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      code: modalData.value,
      gigAmount: modalData.gigAmount,
      compassAmount: modalData.compassAmount,
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        code: values.code,
        gigAmount: values.gigAmount,
        compassAmount: values.compassAmount,
      };
      const reload = () => history.go(0);
      dispatch(updateDeliveryFee(modalData.id, payload, reload));
    },
  });

  const buttonLoadState = deliveryFeeLoading || loading;

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={closeModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-cente justify-center min-h-full p-4 text-cente sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="">
                    <div className="">
                      <div className="mb-6 bg-gray-800 p-4 rounded-t-md">
                        <div className="flex text-xl items-center text-white">
                          <AiOutlineClose
                            onClick={() => closeModal()}
                            className="cursor-pointer"
                          />
                          <div className="ml-auto mr-auto font-bold">
                            Edit Delivery Fee
                          </div>
                        </div>
                      </div>
                      <div className="mt-10 sm:px-6 px-6 w-full">
                        <form>
                          <div className="flex gap-2 mb-2">
                            <div className="w-full">
                              <CustomInput
                                handleChange={handleChange}
                                name="gigAmount"
                                placeholder="GIG Amount"
                                type="number"
                                defaultValue={modalData.gigAmount}
                              />
                              <ErrorInputComponent error={errors.gigAmount} />
                            </div>
                            <div className="w-full">
                              <CustomInput
                                handleChange={handleChange}
                                name="compassAmount"
                                placeholder="Compass Amount"
                                type="number"
                                defaultValue={modalData.compassAmount}
                              />
                              <ErrorInputComponent
                                error={errors.compassAmount}
                              />
                            </div>
                          </div>

                          <div className="inline-block relative w-full mb-3">
                            <select
                              defaultValue={modalData.compassAmount}
                              placeholder="Select station"
                              name="code"
                              onChange={handleChange}
                              className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 pt-4 pb-4 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                            >
                              {names.map((item, index) => {
                                return (
                                  <option key={index} value={item.value}>
                                    {item.station}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                className="fill-current h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                            </div>
                          </div>
                          <ErrorInputComponent error={errors.code} />
                        </form>
                      </div>
                      <BottomButton
                        name={"Proceed"}
                        func={handleSubmit}
                        loading={buttonLoadState}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
